import { createContext, useContext, useState, useMemo, useCallback } from "react";

/**
 * AI Context Provider — lets any page inject a "context" payload that the
 * AIAssistant will automatically pass along with every prompt. This is how we
 * make the assistant data-aware: on Finance page it sees the P&L snapshot,
 * on CRM it sees the selected client, on Capital Planning it sees the filtered assets.
 *
 * Usage from a page:
 *   const { setContext } = useAIContext();
 *   useEffect(() => { setContext({ module: "finance", kpis }); return () => setContext(null); }, [kpis]);
 */
const AIContextCtx = createContext({ context: null, setContext: () => {} });

export function AIContextProvider({ children }) {
  const [context, setContextInner] = useState(null);
  const setContext = useCallback((c) => setContextInner(c), []);
  const value = useMemo(() => ({ context, setContext }), [context, setContext]);
  return <AIContextCtx.Provider value={value}>{children}</AIContextCtx.Provider>;
}

export function useAIContext() {
  return useContext(AIContextCtx);
}
